export class Pagination {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;

  constructor(pageNumber = 1, pageSize = 6, totalRecords = 0, totalPages = 1) {
      this.pageNumber = pageNumber;
      this.pageSize = pageSize;
      this.totalRecords = totalRecords;
      this.totalPages = totalPages;
  }
}
